export const PREFERENCE_KEY = 'cheyu-language-choice'
export function preferredLocale(country, acceptLanguage = '') {
  if (['TW', 'HK', 'MO', 'CN'].includes(country)) return 'zh'
  if (country && country !== 'XX') return 'en'
  return /^zh(?:-|,|;|$)/i.test(acceptLanguage) ? 'zh' : 'en'
}
export function alternatePath(entry, language) {
  return entry?.alternates?.find(path => (path === '/zh/' || path.startsWith('/zh/')) === (language === 'zh')) || null
}
export function autoLocalePath({ path, choice, detected, bot = false }) {
  // An explicit language URL or shared deep link wins over inferred geography.
  if (bot || path !== '/') return null
  const language = ['zh', 'en'].includes(choice) ? choice : detected
  return language === 'zh' ? '/zh/' : null
}
